export const VARIABLES = [
  'contact.id',
  'contact.name',
  'contact.first_name',
  'contact.last_name',
  'contact.email',
  'contact.phone_number',
  'contact.lifecycle_stage',
  'conversation.id',
  'conversation.status',
  'inbox.name',
  'account.name',
];

export const PROVIDER_OPTIONS = [
  {
    value: 'openai',
    labelKey: 'AI_AGENTS.PROVIDERS.OPENAI',
  },
];

export const MODEL_OPTIONS = [
  {
    value: 'gpt-4o-mini',
    label: 'GPT-4o mini',
    provider: 'openai',
  },
  {
    value: 'gpt-4o',
    label: 'GPT-4o',
    provider: 'openai',
  },
  {
    value: 'gpt-4.1-mini',
    label: 'GPT-4.1 mini',
    provider: 'openai',
  },
];

export const TEMPERATURE_OPTIONS = [
  {
    value: 0.2,
    labelKey: 'AI_AGENTS.TEMPERATURES.PRECISE',
  },
  {
    value: 0.3,
    labelKey: 'AI_AGENTS.TEMPERATURES.BALANCED',
  },
  {
    value: 0.7,
    labelKey: 'AI_AGENTS.TEMPERATURES.CREATIVE',
  },
];

export const AI_AGENT_ACTIONS = [
  {
    type: 'close_conversation',
    titleKey: 'AI_AGENTS.ACTION_CARDS.CLOSE_CONVERSATION.TITLE',
    descriptionKey: 'AI_AGENTS.ACTION_CARDS.CLOSE_CONVERSATION.DESCRIPTION',
    instructionKey: 'AI_AGENTS.ACTION_CARDS.CLOSE_CONVERSATION.INSTRUCTION',
    placeholderKey: 'AI_AGENTS.ACTION_CARDS.CLOSE_CONVERSATION.PLACEHOLDER',
  },
  {
    type: 'assign_agent',
    titleKey: 'AI_AGENTS.ACTION_CARDS.ASSIGN.TITLE',
    descriptionKey: 'AI_AGENTS.ACTION_CARDS.ASSIGN.DESCRIPTION',
    instructionKey: 'AI_AGENTS.ACTION_CARDS.ASSIGN.INSTRUCTION',
    placeholderKey: 'AI_AGENTS.ACTION_CARDS.ASSIGN.PLACEHOLDER',
  },
  {
    type: 'update_lifecycle_stage',
    titleKey: 'AI_AGENTS.ACTION_CARDS.LIFECYCLE.TITLE',
    descriptionKey: 'AI_AGENTS.ACTION_CARDS.LIFECYCLE.DESCRIPTION',
    instructionKey: 'AI_AGENTS.ACTION_CARDS.LIFECYCLE.INSTRUCTION',
    placeholderKey: 'AI_AGENTS.ACTION_CARDS.LIFECYCLE.PLACEHOLDER',
  },
  {
    type: 'update_contact_fields',
    titleKey: 'AI_AGENTS.ACTION_CARDS.CONTACT_FIELDS.TITLE',
    descriptionKey: 'AI_AGENTS.ACTION_CARDS.CONTACT_FIELDS.DESCRIPTION',
    instructionKey: 'AI_AGENTS.ACTION_CARDS.CONTACT_FIELDS.INSTRUCTION',
    placeholderKey: 'AI_AGENTS.ACTION_CARDS.CONTACT_FIELDS.PLACEHOLDER',
  },
  {
    type: 'update_tags',
    titleKey: 'AI_AGENTS.ACTION_CARDS.TAGS.TITLE',
    descriptionKey: 'AI_AGENTS.ACTION_CARDS.TAGS.DESCRIPTION',
    instructionKey: 'AI_AGENTS.ACTION_CARDS.TAGS.INSTRUCTION',
    placeholderKey: 'AI_AGENTS.ACTION_CARDS.TAGS.PLACEHOLDER',
  },
  {
    type: 'trigger_workflow',
    titleKey: 'AI_AGENTS.ACTION_CARDS.WORKFLOWS.TITLE',
    descriptionKey: 'AI_AGENTS.ACTION_CARDS.WORKFLOWS.DESCRIPTION',
    instructionKey: 'AI_AGENTS.ACTION_CARDS.WORKFLOWS.INSTRUCTION',
    placeholderKey: 'AI_AGENTS.ACTION_CARDS.WORKFLOWS.PLACEHOLDER',
  },
  {
    type: 'add_comment',
    titleKey: 'AI_AGENTS.ACTION_CARDS.COMMENTS.TITLE',
    descriptionKey: 'AI_AGENTS.ACTION_CARDS.COMMENTS.DESCRIPTION',
    instructionKey: 'AI_AGENTS.ACTION_CARDS.COMMENTS.INSTRUCTION',
    placeholderKey: 'AI_AGENTS.ACTION_CARDS.COMMENTS.PLACEHOLDER',
  },
  {
    type: 'handle_calls',
    titleKey: 'AI_AGENTS.ACTION_CARDS.CALLS.TITLE',
    descriptionKey: 'AI_AGENTS.ACTION_CARDS.CALLS.DESCRIPTION',
    locked: true,
  },
  {
    type: 'make_http_request',
    titleKey: 'AI_AGENTS.ACTION_CARDS.HTTP.TITLE',
    descriptionKey: 'AI_AGENTS.ACTION_CARDS.HTTP.DESCRIPTION',
    locked: true,
  },
];
